/**
 * @fileoverview AR-924 — Slim "Uploading N%" bar of the drawer, shown in every mode while files are sent.
 */

import { Group, Progress, Text } from '@mantine/core'
import { useTranslation } from 'react-i18next'

const BAR_SIZE = 'sm'
/** Keeps the percentage from jumping around as digits change. */
const LABEL_MIN_WIDTH = 96

export function UploadProgressBar({ percent }: { percent: number }) {
  const { t } = useTranslation()
  return (
    <Group spacing="sm" noWrap align="center" role="status" aria-live="polite">
      <Progress value={percent} size={BAR_SIZE} radius="xl" animate sx={{ flex: 1 }} />
      <Text size="xs" weight={600} sx={{ minWidth: LABEL_MIN_WIDTH, textAlign: 'right' }}>
        {t('task_tracker.teacher_upload.uploading', { percent })}
      </Text>
    </Group>
  )
}
